
const columns = [{
    title: '账号',
    name: 'userName',
    dataIndex: 'userName',
    searchItem: {},
    tableItem: {
        width: 150
    }
}, {
    title: '姓名',
    name: 'fullName',
    dataIndex: 'fullName',
    searchItem: {},
    tableItem: {
        width: 100
    }
}, {
    title: '手机号',
    name: 'mobile',
    dataIndex: 'mobile',
    tableItem: {
        width: 120
    }
}, {
    title: '邮箱',
    name: 'email',
    dataIndex: 'email',
    tableItem: {
        width: 100
    }
}, {
    title: '状态',
    name: 'state',
    dataIndex: 'state',
    dict: [
        { code: 1, codeName: '激活' },
        { code: 0, codeName: '禁用' },
    ],
    tableItem: {
        width: 100
    }
}]

const tableApi = {
    path: 'integrationCounseling/teacherList'
}

const teacher = {
    type: 'diy',
    initialValue: [],
    rowKey: 'personId',
    rowTitle: 'userName',
    rowName: 'fullName',
    title: '选择辅导老师',
    columns,
    tableApi
}

export default teacher
